<template>
  <router-view />
  <NewVersionBanner />
  <SessionLockedOverlay />
</template>

<script setup lang="ts">
import { setUnauthorizedHandler } from "./api/client"
import { startApp } from "./app/appInit"
import { useAuthStore } from "./stores/auth"
import { pageTitle } from "./utils/format"
import { useMeta } from "quasar"
import { onMounted } from "vue"
import NewVersionBanner from "./components/NewVersionBanner.vue"
import SessionLockedOverlay from "./components/SessionLockedOverlay.vue"

const isDevSystem = process.env.OPS_SYSTEM === "DEV"
const base = isDevSystem ? "bx:DEVops" : "bx:ops"

useMeta({
  titleTemplate: (title) => pageTitle(title, base),
})

onMounted(() => {
  // Wire the API client's 401 handler to the auth-store lock-out.
  setUnauthorizedHandler(() => useAuthStore().lockOut())
  startApp()
})
</script>
